import React from 'react';
import { Box, Grid, Container } from '@material-ui/core';
import Footer from '../components/reusableComponents/Footer';
import Headers from '../components/reusableComponents/Headers';
import Nepa1 from '../assets/images/Nepal1.jpeg';
import Nepal2 from '../assets/images/Nepal2.jpeg';
import Nepal3 from '../assets/images/Nepal3.jpeg';
import Nepal4 from '../assets/images/Nepal4.jpeg';
import Nepal5 from '../assets/images/Nepal5.jpeg';
import EnquiryForm from '../form/EnquiryForm';
const data = [
	{
		title: 'Introduction to Kolkata',
		image: Nepal3,
		desc: 'Officially, the Kingdom of Thailand, Thailand is a country in Southeast Asia spanning 513,120 km2 and with a population of around 70 million. Bangkok is the capital and the largest cit The country is bordered by Myanmar, Laos, Cambodia, and Malaysia. It also shares maritime borders with Vietnam, Indonesia, and India. Thailand was earlier known as Siam. The word Thai means ‘free man’ in the Thai language. There’s an influence of Sanskrit in the development of the Thai language. Thailand’s climate is influenced by monsoon winds and most of the country has a tropical rainforest climate. The economy of Thailand is heavily export-dependent, with exports accounting for more than two-thirds of the gross domestic product (GDP). 49% of Thailand’s labor force is employed in agriculture. Rice is the most important crop in the country. Tourism makes up about 14% of the country’s economy. In 2019, Thailand received 39.8 million international tourists and received the fourth-highest international tourism earnings at 60.5 billion US dollars.',
	},
	{
		title: 'Day 1',
		image: Nepal2,
		desc: 'I always wanted to visit Thailand because of the historical connections between India and Thailand. Veena World became our natural choice as my parents had already traveled with them across India and were confident and comfortable with the travel arrangements by them. My parents visited the Veena World Thane office and were guided by Sneha Rane, Veena World representative in making the selection of ASTJ – Thai Jewels as we wanted to celebrate New Year’s Eve in a foreign destination. The ASTJ – Thai Jewels tour was a group tour for 6 Days and 5 Nights from 30th Dec 2022 to 4th Jan 2023. This tour covered two cities viz. Bangkok and Pattaya. We started our journey from Chhatrapati Shivaji Maharaj International Airport, Mumbai on the 29th Dec evening as we had to board the Air India flight on the 30th Dec 2022 at 1.30 am. We were all excited about this tour and seeing exciting places in Thailand. We met our Tour Managers Vivek Kocharekar and Mahendra Wadkar at the airport and our fellow travelers. For Indians traveling to Thailand, there is a provision for a ‘Visa on arrival’ at the Suvarnabhumi Airport in Bangkok.',
	},
	{
		title: 'Day 2: ',
		image: Nepal4,
		desc: 'On 30th Dec 2022, we reached Bangkok early in the morning and we were guided to our Bus- Coach; where we met Rudy, our local Tour Guide and Lift our Coach Diver. We were taken to our 1st destination at Madame Tussauds Wax Museum, which was a nice experience as they had a plethora of wax statues of various celebrities. Post that we checked in to our Hotel Ramada by D’MA which was centrally located and near Indra market. Later in the evening we could just walk down to the Indra Market mall and enjoy our shopping.',
	},
	{
		title: 'Day 3',
		image: Nepal5,
		desc: 'On 30th Dec 2022, we reached Bangkok early in the morning and we were guided to our Bus- Coach; where we met Rudy, our local Tour Guide and Lift our Coach Diver. We were taken to our 1st destination at Madame Tussauds Wax Museum, which was a nice experience as they had a plethora of wax statues of various celebrities. Post that we checked in to our Hotel Ramada by D’MA which was centrally located and near Indra market. Later in the evening we could just walk down to the Indra Market mall and enjoy our shopping.',
	},
];
const BlogDetailSection = () => {
	return (
		<>
			<Headers />
			<Container style={{ marginTop: 40, marginBottom: 40 }}>
				<Grid container spacing={4}>
					<Grid item xs={8}>
						<Box>
							<img
								src={Nepa1}
								style={{ width: '100%', height: '100%', borderRadius: 5 }}
							/>
							<h1 style={{ marginTop: 26, fontSize: 24 }}>
								Kolkata Travel Blog
							</h1>
							<span style={{ color: 'grey' }}>By Musafir Bazar</span>
							{data.map((d) => {
								return (
									<Box>
										<h3 style={{ marginTop: 10, fontWeight: 'bold' }}>
											{d.title}
										</h3>
										<img src={d.image} />
										<p style={{ color: 'grey', marginTop: 10 }}>{d.desc}</p>
									</Box>
								);
							})}
						</Box>
					</Grid>
					<Grid item xs={4}>
						<Box>
							<h3>Quick Enquiry</h3>
							<EnquiryForm />
						</Box>
					</Grid>
				</Grid>
			</Container>
			<Footer />
		</>
	);
};

export default BlogDetailSection;
